export const PEN_COLOUR = "rgba(181, 18, 27, 1)";
